import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2 12.667h12v1.334H2zm6.667-3.885 4.047-4.048.943.943L8 11.334 2.343 5.677l.943-.943 4.047 4.048V1.334h1.334z"
    }, null, -1)
  ]))]))
}
export default { render: render }